var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterEfficiency1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.66 8.00001L12 2.35001L6.34 8.00001C4.78 9.56001 4 11.64 4 13.64C4 15.64 4.78 17.75 6.34 19.31C7.9 20.87 9.95 21.66 12 21.66C14.05 21.66 16.1 20.87 17.66 19.31C19.22 17.75 20 15.64 20 13.64C20 11.64 19.22 9.56001 17.66 8.00001Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.66 8.00001L12 2.35001L6.34 8.00001C4.78 9.56001 4 11.64 4 13.64C4 15.64 4.78 17.75 6.34 19.31C7.9 20.87 9.95 21.66 12 21.66C14.05 21.66 16.1 20.87 17.66 19.31C19.22 17.75 20 15.64 20 13.64C20 11.64 19.22 9.56001 17.66 8.00001Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterEfficiency1);
export default __webpack_public_path__ + "static/media/Water Efficiency-1.c5fc5047c28f96a7e119d4e0a5a9eaf4.svg";
export { ForwardRef as ReactComponent };